export const extractErrorMessage = (error) => {
    let message = "We apologize... This action can't be done";
    if (!error) {
        return message;
    }

    if (typeof error === "string") {
        message = error;
    } else if (typeof error === "object") {
        if ("errorMsg" in error && error.errorMsg.length > 0) {
            message = error.errorMsg;
        }
        if ("errorMessage" in error && error.errorMessage.length > 0) {//existing error payload reparsed
            message = error.errorMessage;
        }
        if ("errorDetails" in error) {//server error with details
            if (Array.isArray(error.errorDetails) && error.errorDetails[0].msg && error.errorDetails[0].msg.length > 0) {
                message = error.errorDetails[0].msg;
            } else if (typeof error.errorDetails === "string" && error.errorDetails.length > 0) {
                message = error.errorDetails;
            } else if (typeof error.errorDetails === "object") {
                if ("msg" in error.errorDetails && error.errorDetails.msg.length > 0) {
                    message = error.errorDetails.msg;
                }
            }
        }
    }

    return message;
};

export const extractErrorCode = (error) => {
    let errorCode = 0;
    if (!error) {
        return errorCode;
    }

    if (typeof error === "object") {
        errorCode = error.errorDetailsCode || error.errorCode;
    }

    return errorCode;
}

export const parseErrorAndReturnPayload = (error) => {
    const payload = {
        errorCode: 0,
        errorMessage: ""
    }
    if (error && error instanceof Error) {
        payload.errorMessage = error.message;
    } else {
        payload.errorCode = extractErrorCode(error);
        payload.errorMessage = extractErrorMessage(error);
    }

    return payload;
}

export const parseErrorMessageArray = (errorArray) => {
    let errorMessage = "";
    if (errorArray) {
        errorArray.map(item => {
            Object.entries(item).forEach(([key, value]) => {
                errorMessage += key + ": " + value.errorMessage + "\n";
            })
        });
    }
    return errorMessage;
}

export const isMainPageIndex = (htmlIndex) => {
    if (typeof htmlIndex === "string") {
        const foundMainPageTitle = htmlIndex.match(/<title>Rainbow for Developers<\/title>/);
        return foundMainPageTitle != null;
    }
    return false;
}